import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS]
		.GET_WORKS_SERVICE_PAYMENT_RATE_NORMS]: {
		url: '/company/:companyId/works_service_payment_rates_norms/',
	},
	[ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS]
		.GET_WORKS_SERVICE_PAYMENT_RATE_NORM]: {
		url: '/company/:companyId/works_service_payment_rates_norms/:worksServicePaymentRateNormId/',
	},
	[ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS]
		.CREATE_WORKS_SERVICE_PAYMENT_RATE_NORM]: {
		url: '/company/:companyId/works_service_payment_rates_norms/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS]
		.PATCH_WORKS_SERVICE_PAYMENT_RATE_NORM]: {
		url: '/company/:companyId/works_service_payment_rates_norms/:worksServicePaymentRateNormId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS]
		.PUT_WORKS_SERVICE_PAYMENT_RATE_NORM]: {
			url: '/company/:companyId/works_service_payment_rates_norms/:worksServicePaymentRateNormId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS]
		.DELETE_WORKS_SERVICE_PAYMENT_RATE_NORM]: {
		url: '/company/:companyId/works_service_payment_rates_norms/:worksServicePaymentRateNormId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}
